export default {
  about: 'O',
  addOns: 'Doplňky',
  agenda: 'Program',
  all: 'Vše',
  browse: 'Procházet',
  buyTickets: 'Koupit lístky',
  countSelected: 'Vybráno {{count}}',
  included: 'Zahrnuto',
  joinWaitlist: 'Připojit se na čekací listinu',
  joining: 'Připojování',
  menu: 'Menu',
  noDatesAvailable: 'Žádné dostupné termíny',
  salesEnded: 'Prodej ukončen',
  schedule: 'Rozvrh',
  seeMoreDates: 'Zobrazit více termínů',
  soldOut: 'Vyprodáno',
  viewMore: 'Zobrazit více',
  viewLess: 'Zobrazit méně',
  location: 'Místo',
  time: 'Čas',
  at: 'v',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Na tento datum nejsou k dispozici žádné časy pro tuto velikost skupiny',
  availableTimes: 'Dostupné časy',
  waitlist: 'Čekací listina',
  continue: 'Pokračovat',
  tickets: 'Vstupenky',
  ticketsAreNoLongerAvailable: 'Lístky již nejsou k dispozici.',
  checkOutOutOtherExperiences: 'Podívejte se na naše další zážitky!',
  viewExperiences: 'Zobrazit zážitky',
  from: 'od',
  cancellationPolicy: 'Zásady zrušení',
  rsvp: 'RSVP',
  nights: 'nocí',
  request: 'Žádost',
  arrival: 'Příjezd',
  departure: 'Odjezd',
};
